import { useEffect, useState } from "react"
import { useRoutesHooks } from "../../../../../features/routes"
import { PanelLoader, useGetCrumbs, useUIStateActions } from "../../../../../features/ui"
import { Operation, useOperationLoaders } from "../../../../operations"
import { DeliveryMethod, DeliveryOrder } from "../../../state/types"
import { describeHelpers, Labels } from "../../../../../features/data-types"
import { DeliveryForm } from "./deliveryForm"
import { deliveryOrderHelpers } from "../../../hooks/deliveryOrderHooks"

export const DeliveryFormLoader = () => {
    const { dataType } = useRoutesHooks().parseUrl()
    const deliveryOrder = dataType! as DeliveryOrder

    const [ready, setReady] = useState(false)
    const [operation, setOperation] = useState<Operation>()

    const { describeCode } = describeHelpers
    const { describeDeliveryOrder, getDeliveryMethodRoutPath } = deliveryOrderHelpers
    
    const operationLoaders = useOperationLoaders()
    const { setDisableBranchSelector } = useUIStateActions()

    const load = async () => {
        const { loadOperation } = operationLoaders()
        const loadedOperation = await loadOperation(deliveryOrder.table, deliveryOrder.operationId)
        setOperation(loadedOperation)
    }

    useEffect(() => {
        setDisableBranchSelector(true)
        load().then(() => setReady(true))
        return () => {
            setDisableBranchSelector(false)
        }
    }, [])

    const isShipment = deliveryOrder.method === DeliveryMethod.SHIPMENT
    const title = isShipment ? 'Generar Remito' : `Completar ${describeDeliveryOrder(deliveryOrder)}`

    const crumbs = useGetCrumbs(
        `Órdenes de ${Labels.deliveryMethodLabel(deliveryOrder.method)}`,
        getDeliveryMethodRoutPath(deliveryOrder.method),
        describeCode(deliveryOrder),
        deliveryOrder.id,
        title
    )

    return (
        <PanelLoader
            title={title}
            crumbs={crumbs}
            ready={ready}
            wide
        >
            <DeliveryForm
                deliveryOrder={deliveryOrder}
                operation={operation!}
            />
        </PanelLoader>
    )
}
